module.exports = __webpack_public_path__ + "img/prva-osmrtnice.svg";